// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".top-swiper", {
  loop: true, // ループ
  speed: 1500, // 少しゆっくり(デフォルトは300)
  effect: 'fade', // フェード
  autoplay: { // 自動再生
    delay: 1000, // 2秒後に次のスライド
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },
});


jQuery(function ($) {
  var $target = $('.p-frontFv__copy__txt');
  var hasAnimated = false;

  $(window).on('scroll', function () {
    if (hasAnimated) return;

    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var offsetTop = $target.offset().top;

    if (scrollTop + windowHeight > offsetTop + 100) {
      // +100 は少し余裕をもたせるオフセット
      $target.addClass('inview');
      hasAnimated = true; // 一度だけ実行
    }
  });
});
